Vue.asyncComponent('cms-dashboard-favicon-check', {
    props: {
        statusLabel: {
            type: String,
            default: '',
        },
        statusValue: {
            type: String,
            default: '',
        },
        statusDescription: {
            type: String,
            default: '',
        },
        statusTone: {
            type: String,
            default: 'success',
        },
        fields: {
            type: Array,
            default: () => [],
        },
        configuredFieldCount: {
            type: Number,
            default: 0,
        },
    },
}, 'cms/dashboard/live/cms-dashboard-favicon-check.html');
